import React, { useRef, useState, useEffect, useMemo  } from 'react';
import { Box, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import * as yup from 'yup';
import _ from 'lodash';
import { useFormik, FormikProvider } from 'formik';
import * as chanceApi from '../../../lib/api/chance';
import {
  chanceEstimateActive,
  chanceOrderCount,
  setChance,
} from '../../../modules/chanceModule/chance';
import DetailTemplate from '../../../components/common/template/DetailTemplate';
import CostCalcLockContainer from '../costcalc/CostCalcLockContainer';
import CostSummary from '../../../components/chancemng/costcalc/CostSummary';
import CostCalcListForm from '../../../components/chancemng/costcalc/CostCalcListForm';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { listChanceCosts } from '../../../modules/chanceModule/chanceCosts';
import ForecastBaseInfoForm from '../../../components/common/base/ForecastBaseInfoForm';
import {getInitialFormValues} from '../../../components/common/base/ForecastBaseInfoInit';
import { getBaseCodes } from '../../../modules/auth';
import { validationForecast } from '../../../components/common/util/ForecastValid';

const ChanceNeedsAnanlysisFormContainer = ({ stepperRef }) => {
  const arrayHelperRef = useRef();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { baseCodes, user, chance, costs} = useSelector(
    
    ({ auth, chanceModule }) => ({
      baseCodes: auth.baseCodes,
      user: auth.user,
      chance: chanceModule.chance.chance,
      costs: chanceModule.chanceCosts.costs,
    }),
  );

  const [itemCdOptions, setItemCdOptions] = useState([]);
  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };
  const onConfirm = () => {
    setVisible(false);
  };
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [message, setMessage] = useState(
    '기본사항 등록이 완료되지 못했습니다.',
  );

  const checkValidation = () => {
    let valid = true;
    //원가산출 체크
    if (formik.values.costCalcs?.length === 0) {
      setMessage(
        '원가 산출 제품을 추가하지 않았습니다. 원가 산출 내역을 확인하세요.',
      );
      valid = false;
    }

    return valid;
  };

const onSelectedProducts = (data) => {
  const products = [...selectedProducts, ...data];
  const filteredProducts = _.uniqBy(products, 'id');

  filteredProducts.forEach((product) => {
    // 1. 현재 Formik values에서 동일한 partnerUuid를 가진 마지막 인덱스를 찾음
    const currentList = formik.values.costCalcs;
    // 뒤에서부터 찾아서 해당 파트너의 가장 마지막 위치를 파악
    const lastIndex = _.findLastIndex(currentList, { partnerUuid: product.partnerUuid });

    const newRow = {
      expUuid: product.expUuid || '',
      masterTyp: 'N',
      priceUuid: product.priceUuid,
      sellPartnerUuid: product.partnerUuid,
      sellPartnerNm: product.partnerNm,
      partnerUuid: product.partnerUuid,
      partnerNm: product.partnerNm,
      productNm: product.productNm,
      productUuid: product.productUuid,
      expCnt: 1,
      unitVal: product.unitVal,
      unitValIn: product.unitValIn,
      saleVal: product.unitVal || 0,
      saleValIn: product.unitValIn || 0,
      priceVal: product.priceVal,
      buyVal: product.priceVal || 0,
      priceValIn: product.priceValIn,
      productDesc: product.productDesc,
      productUnit: product.productUnit,
      itemCd: product.itemCd,
      // 개별 계산을 위해 타입 초기값 추가 추천
      salesType: 'unitVal',
      purchaseType: 'priceVal'
    };

    if (lastIndex !== -1) {
      // 2. 동일 파트너가 있으면 그 다음 칸에 삽입
      arrayHelperRef.current.insert(lastIndex + 1, newRow);
    } else {
      // 3. 동일 파트너가 없으면 맨 뒤에 추가
      arrayHelperRef.current.push(newRow);
    }
  });
};


  const handleExtProduct = () => {
    arrayHelperRef.current.push({
      masterTyp: 'E',
      priceUuid: null,
      sellPartnerUuid: '',
      sellPartnerNm: '(주)에이치씨인포',
      partnerUuid: null,
      partnerNm: null,
      productNm: '',
      productUuid: null,
      expCnt: 1,
      unitVal: 0,
      unitValIn: 0,
      saleVal: 0,
      saleValIn: 0,
      priceVal: 0,
      buyVal:  0,
      priceValIn: 0,
      productDesc: '',
      productUnit: '',
      itemCd: '기타',
      salesType: 'unitVal',
      purchaseType: 'priceVal', 
    });
  };

  const [initialValues, setInitialValues] = useState(getInitialFormValues());
  useEffect(() => {
    if (!baseCodes) {
      dispatch(getBaseCodes());
    } else {
      const filteredList = _.filter(baseCodes, {
        blcCd: 'BASE',
        mlcCd: 'PRODUCT',
        slcCd: 'CATEGORY',
        useYn: 'Y',
      }).map((item) => ({
        ...item,
        step: item.step !== '' && item.step !== null ? parseInt(item.step) : 0,
      }));
      const orderedLiist = _.orderBy(filteredList, 'step');

      setItemCdOptions(orderedLiist);
    }
  }, [baseCodes]);

  useEffect(() => {
    if (chance) {
      dispatch(listChanceCosts(chance.prjUuid));
      const baseLayout = getInitialFormValues(); 
      const merged = _.mergeWith({}, baseLayout, chance, (objValue, srcValue, key) => {

        if (key === 'invoiceToBe') {
          return _.mergeWith({}, baseLayout.invoiceToBe, srcValue || {}, (o, s) => s == null ? '' : undefined);
        }

        if (srcValue == null) return '';
        if (_.isDate(srcValue)) return srcValue;
        if (_.isArray(srcValue)) return [...srcValue];
      });

      setInitialValues(merged);
    }
  }, [chance, dispatch]);

  useEffect(() => {
    if (costs) {
      const mappedCosts = costs.map(item => ({
        ...item,
        salesType: item.salesType || 'unitVal',
        purchaseType: item.purchaseType || 'priceVal'
      }));

      setInitialValues(prev => ({
        ...prev,
        costCalcs: _.cloneDeep(mappedCosts) 
      }));
    }
  }, [costs]);

const memoizedInitialValues = useMemo(() => {
  if (!initialValues) return {};

  return {
    ...initialValues,
    costCalcs: (initialValues.costCalcs || []).map((item) => ({
  ...item,
  // 기존에 값이 있다면(금액조정 행의 saleValIn 포함) 그 값을 유지하고, 없을 때만 기본값 부여
  salesType: item.salesType ? item.salesType : 'unitVal',
  purchaseType: item.purchaseType ? item.purchaseType : 'priceVal',
  isAdjustment: item.masterTyp === 'BAL' || item.isAdjustment,
})),
  };
}, [initialValues]); // 서버 데이터(DTO)가 변경될 때만 실행

  const formik = useFormik({
    initialValues: memoizedInitialValues,
    enableReinitialize: true,
    validationSchema: validationForecast(),
    onSubmit: async (values, { setSubmitting }) => {
      const valid = checkValidation();
      if (!valid) {
        setVisible(true);
        return;
      } else {
        setSubmitting(true);
        onSave(values);
        formik.resetForm();
        setSubmitting(false);
      }

      stepperRef.current?.scrollIntoView({ behavior: 'smooth' }); //저장 후 stepper로 이동함.
    },
  });

  const onSave = async (values) => {
    let dataToSubmit = {
      prjUuid: chance.prjUuid,
      cstNm: values.cstNm.trim(),
      prjTyp: values.prjTyp,
      prjImpt: values.prjImpt,
      bugetYn: values.bugetYn,
      partnerTyp: values.partnerTyp,
      clientTyp: values.clientTyp,
      incClientTyp: values.incClientTyp,
      forcastTxt: values.forcastTxt,
      productYn: values.productYn,
      clientCmp: values.clientCmp,
      vendorCmp: values.vendorCmp,
      crtUsr: values.crtUsr,
      expDay: values.expDay ? dayjs(values?.expDay).format('YYYY-MM-DD') : null,
      salesTyp: values.salesTyp,
      procurement:values.procurement,
      customerCf:values.customerCf,
      ...(values.prjTyp === 'M' && {
        invoiceToBe: {
          prjUuid: chance.prjUuid,
          contractStDt: values.invoiceToBe.contractStDt ? dayjs(values.invoiceToBe.contractStDt).format('YYYY-MM-DD') : null,
          contractEdDt: values.invoiceToBe.contractStDt ? dayjs(values.invoiceToBe.contractEdDt).format('YYYY-MM-DD') : null,
          inspectYn: values.invoiceToBe.inspectYn,
          invTo: values.invoiceToBe.invTo,
          invMonth : values.invoiceToBe.invMonth,
          invDay: values.invoiceToBe.invDay,
          colTo: values.invoiceToBe.colTo,
          colDay: values.invoiceToBe.colDay,
          colMonth : values.invoiceToBe.colMonth,
          lockYn: values.invoiceToBe.lockYn,
          crtUsr: values.crtUsr,
          dateSchedules: Array.isArray(values.invoiceToBe?.dateSchedules) 
          ? values.invoiceToBe.dateSchedules 
          : [] 
        }       
      })
    };

    try {
      
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data.info) {
        const calcData = onMakeCaclData();
        const calcRes = await chanceApi.editCosts(chance.prjUuid, calcData);
        formik.setValues({
          ...res.data.info  // 서버에서 넘겨준 최신 객체로 덮어쓰기
       });
        if (calcRes.data) {
          dispatch(setChance(res.data.info));
          dispatch(listChanceCosts(chance.prjUuid));
          enqueueSnackbar(`저장 성공`, {
            variant: 'success',
          });
        }
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };
const onMakeCaclData = () => {
  return formik.values.costCalcs.map((item) => {
    const toNum = (val) => {
      if (val === undefined || val === null || String(val).trim() === '') return 0;
      const num = Number(String(val).replace(/[^0-9.-]/g, ''));
      return isNaN(num) ? 0 : num;
    };

    const calcVatIn = (val) => Math.trunc(val * 1.1 + 0.0001);
    const calcExVat = (val) => Math.trunc(val / 1.1 + 0.0001);

    const count = toNum(item.expCnt);
    const salesType = item.salesType || 'unitVal';
    const purchaseType = item.purchaseType || 'priceVal';

    let uVal = toNum(item.unitVal);    // 매출 단가
    let sVal = toNum(item.saleVal);    // 매출 공급가
    let sValIn = toNum(item.saleValIn);// 매출 합계

    let pVal = toNum(item.priceVal);   // 매입 단가
    let bVal = toNum(item.buyVal);     // 매입 공급가
    let bValIn = toNum(item.priceValIn); // 매입 합계

    if (!item.isAdjustment) {
      
      // 1. 매출 관련 계산 (salesType)
      switch (salesType) {
        case 'unitVal':
          sVal = uVal * count;
          sValIn = calcVatIn(sVal);
          break;
        case 'saleVal':
          uVal = count !== 0 ? sVal / count : 0;
          sValIn = calcVatIn(sVal);
          break;
        case 'saleValIn':
          sVal = calcExVat(sValIn);
          uVal = count !== 0 ? sVal / count : 0;
          break;
      }

      // 2. 매입 관련 계산 (purchaseType)
      switch (purchaseType) {
        case 'priceVal': // 매입 단가 기준
          bVal = pVal * count;
          bValIn = calcVatIn(bVal);
          break;
        case 'buyVal': // 매입 공급가 기준
          pVal = count !== 0 ? bVal / count : 0;
          bValIn = calcVatIn(bVal);
          break;
        case 'priceValIn': // 매입 합계금액 기준
          bVal = calcExVat(bValIn);
          pVal = count !== 0 ? bVal / count : 0;
          break;
      }
    }

    // 최종 데이터 반환
    return {
      ...item,
      expCnt: count,
      // 매출 필드
      unitVal: uVal,
      unitValIn: calcVatIn(uVal),
      saleVal: sVal,
      saleValIn: sValIn,
      // 매입 필드
      priceVal: pVal,
      priceValIn: bValIn, // UI에서 priceValIn을 합계로 사용
      buyVal: bVal,
      // 수익 계산
      saleProfit: sVal - bVal,
      saleProfitIn: sValIn - bValIn,
      salePct: sVal !== 0 ? ((sVal - bVal) / sVal) * 100 : 0,
      salesType,
      purchaseType
    };
  });
};



  const [totalPurchase, setTotalPurchase] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [totalSalesIn, setTotalSalesIn] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalProfitIn, setTotalProfitIn] = useState(0);
  const [totalMargin, setTotalMargin] = useState(0);
  const [totalMarginIn, setTotalMarginIn] = useState(0);

  useEffect(() => {
    let purchase = 0;
    let sales = 0;
    let salesIn = 0;
    let profit = 0;
    let profitIn = 0;
    _.each(formik.values?.costCalcs, (product) => {
      purchase += Number(product.buyVal);
      sales += Number(product.saleVal);
      salesIn += Number(product.saleValIn);
    });
    profit = Number(sales - purchase);
    let rate =
      profit === 0 ? 0 : (Number(sales - purchase) / Number(sales)) * 100;

    profitIn = Number(salesIn - purchase);
    let rateIn =
      profitIn === 0 ? 0 : (Number(salesIn - purchase) / Number(salesIn)) * 100;

    setTotalPurchase(purchase);
    setTotalSales(sales);
    setTotalSalesIn(salesIn);
    setTotalProfit(profit);
    setTotalProfitIn(profitIn);
    setTotalMargin(rate.toFixed(3));
    setTotalMarginIn(rateIn.toFixed(3));
  }, [formik.values?.costCalcs]);

  //원가산출 확정/ 해제
  const [lockMessage, setLockMessage] = useState(false);
  const handleLockOpen = () => setLockMessage(true);
  const handleLockClose = () => {
    setLockMessage(false);
  };
  const onCostLock = async () => {
    const valid = checkValidation();

    if (valid) {
      try {
        const res = await chanceApi.completeCost(chance.prjUuid);
        if (res.data.result === 'SUCCESS') {
          dispatch(setChance(res.data.info));
          enqueueSnackbar('원가산출이 확정되었습니다', {
            variant: 'success',
          });
        } else {
          let message = '';
          if (res.data.result === 'NOT_FOUND_COST_INFO') {
              message = '원가산출을 확정할 수 없습니다';
          }
          enqueueSnackbar(`${message}`, {
            variant: 'error',
          });
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    } else {
      handleLockOpen();
    }
  };

  const [unLockVisible, setUnlockVisible] = useState(false);
  const onUnLockCancle = () => {
    setUnlockVisible(false);
  };
  const onUnLockConfirm = () => {
    setUnlockVisible(false);
    onCostUnLock();
  };
  const onCostUnLock = async () => {
    try {
      const res = await chanceApi.unDoCost(chance.prjUuid);

      if (res.data.info) {
        dispatch(setChance(res.data.info));
        dispatch(chanceEstimateActive(chance.prjUuid));
        dispatch(chanceOrderCount(chance.prjUuid));
        enqueueSnackbar('원가산출이 해제되었습니다.', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };
  useEffect(() => {
    // 0번 행의 데이터를 안전하게 가져옴
    const firstItem = formik.values.costCalcs?.[0];
    if (!formik.values.globalSalesType) {
      // 1순위: 0번 행의 salesType, 2순위: 로컬스토리지, 3순위: 기본값
      const savedSales = firstItem?.salesType || localStorage.getItem('lastSalesType') || 'unitVal';
      formik.setFieldValue('globalSalesType', savedSales);
    }
  
    if (!formik.values.globalPurchaseType) {
      const savedPurchase = firstItem?.purchaseType || localStorage.getItem('lastPurchaseType') || 'priceVal';
      formik.setFieldValue('globalPurchaseType', savedPurchase);
    }
  }, [formik.values.costCalcs?.length]);
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '-17px',
        marginRight: '-17px',
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          my: 2,
        }}
      >
        {chance?.costYn === 'Y' ? (
          <Button
            variant="contained"
            color="warning"
            onClick={() => setUnlockVisible(true)}
          >
            원가 산출 해제
          </Button>
        ) : (
          <Button variant="contained" color="warning" onClick={onCostLock}>
            원가 산출 확정
          </Button>
        )}

        <Button
            type="submit"
            variant="outlined"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
      </Box>

      {chance?.useYn === 'N' && (
        <DetailTemplate title="포캐스팅 실패 사유">
          <Box sx={{ whiteSpace: 'pre-line' }}>{chance?.failTxt}</Box>
        </DetailTemplate>
      )}

      <ForecastBaseInfoForm formik={formik} chance={chance} />

      <DetailTemplate title="원가 산출 내역">
        {chance && chance?.costYn === 'Y' ? (
          <CostCalcLockContainer chance={chance} 
                totalPurchase={totalPurchase}
                totalSales={totalSales}
                totalSalesIn={totalSalesIn}
                totalProfit={totalProfit}
                totalProfitIn={totalProfitIn}
                totalMargin={totalMargin}
                totalMarginIn={totalMarginIn}/>
        ) : (
          <Box>
            {/**
            <Box sx={{ mb: 2 }}>
              <CostSummary
                costsVat={costs}
                totalPurchase={totalPurchase}
                totalSales={totalSales}
                totalSalesIn={totalSalesIn}
                totalProfit={totalProfit}
                totalProfitIn={totalProfitIn}
                totalMargin={totalMargin}
                totalMarginIn={totalMarginIn}
              />
            </Box>
             */}
            <FormikProvider value={formik}>
              <CostCalcListForm
                formik={formik}
                ArrayHelperRef={arrayHelperRef}
                selectedVendor={formik.values.vendorCmp}
                itemCdOptions={itemCdOptions}
                onSelectedProducts={onSelectedProducts}
                onAddEtcProduct={handleExtProduct}
              />
            </FormikProvider>
          </Box>
        )}
      </DetailTemplate>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          my: 2,
        }}
      >
        {chance?.costYn === 'Y' ? (
          <Button
            variant="contained"
            color="warning"
            onClick={() => setUnlockVisible(true)}
          >
            원가 산출 해제
          </Button>
        ) : (
          <Button variant="contained" color="warning" onClick={onCostLock}>
            원가 산출 확정
          </Button>
        )}

        <Button
          type="submit"
          variant="outlined"
          disabled={formik.isSubmitting}
        >
          저장
        </Button>

      </Box>
      <AskDialog
        visible={lockMessage}
        title="원가산출 확정 확인"
        description={`원가산출내역에 입력되지 않은 항목이 있습니다\r\n 원가산출을 재확인하세요`}
        confirmText="닫기"
        onConfirm={handleLockClose}
        onCancle={handleLockClose}
      />
      <AskDialog
        visible={unLockVisible}
        title="프로젝트 원가 산출 해제"
        description={`원가산출을 해제하시겠습니까?\r\n작업된(견적서 / 수주품의서 ) 등의 사항을 다시 작성해야됩니다.`}
        confirmText="해제"
        onConfirm={onUnLockConfirm}
        onCancle={onUnLockCancle}
      />
      <AskDialog
        visible={visible}
        title="등록 오류"
        description={message}
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </Box>
  );
};

export default ChanceNeedsAnanlysisFormContainer;
